import type {
  CalendarDayBellTimeFilter,
  CalendarDayInfoFilter,
  CalendarEventFilter,
  CalendarEventRawFilter,
  CalendarGridFilter,
  Calendar_EventTagFilter,
  FindFreeResourcesFilter,
} from '@tyro/api';

export const calendarKeys = {
  all: ['calendar'] as const,
  search: (query: string) => [...calendarKeys.all, 'search', query] as const,
  events: (filter: CalendarEventFilter) =>
    [...calendarKeys.all, 'events', filter] as const,
  timetable: (filter: CalendarEventFilter) =>
    [...calendarKeys.all, 'timetable', filter] as const,
  dayInfo: (filter: CalendarDayInfoFilter) =>
    [...calendarKeys.all, 'timetable', 'day-info', filter] as const,
  createEvent: () => [...calendarKeys.all, 'createEvent'] as const,
  roomLocation: (filter: FindFreeResourcesFilter) =>
    [...calendarKeys.all, 'roomLocation', filter] as const,
  calendarDayBellTimes: (filter: CalendarDayBellTimeFilter) =>
    [...calendarKeys.all, 'calendarDayBellTimes', filter] as const,
  eventsForEdit: (filter: CalendarEventRawFilter) =>
    [...calendarKeys.all, 'eventsForEdit', filter] as const,
  gridPeriods: (filter: CalendarGridFilter) =>
    [...calendarKeys.all, 'gridPeriods', filter] as const,
  tags: (filter: Calendar_EventTagFilter) =>
    [...calendarKeys.all, 'tags', filter] as const,
  embeddableCalendarConfig: () =>
    [...calendarKeys.all, 'embeddableCalendarConfig'] as const,
};
